module.exports = __webpack_public_path__ + "img/openbadge-intro-1.fe3c30f3.png";